import { render, staticRenderFns } from "./TwoFAChallenge.vue?vue&type=template&id=0bfe395c"
import script from "./TwoFAChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFAChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports